// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IkBGz","fullImg":"styles_fullImg__g0dog"};